export const permissionType = {
    CREATE : "C",
    READ : "R",
    UPDATE : "U",
    DELETE : "D",
    SEARCH : "S"
}